module.exports = function() {
  return new Worker(__webpack_public_path__ + "697412df28da13a59ccb.worker.js");
};